import { DEFAULT_LOCALE_EN } from "./languages/en";
import { DEFAULT_LOCALE_TH } from "./languages/th";

export const LOCALE: any = {
  en: DEFAULT_LOCALE_EN,
  th: DEFAULT_LOCALE_TH,
};
